import axios from 'axios';
import { getExpressAPIHost } from '../../../../utils';

const cancelDeliveryDocumentsDownload = (token) => axios.delete(`${getExpressAPIHost()}/delivery-documents/zip/${token}`).catch(() => undefined);

export default cancelDeliveryDocumentsDownload;
